import { render, staticRenderFns } from "./placard_fill.vue?vue&type=template&id=f281c58e&scoped=true"
import script from "./placard_fill.vue?vue&type=script&lang=js"
export * from "./placard_fill.vue?vue&type=script&lang=js"
import style0 from "./placard_fill.vue?vue&type=style&index=0&id=f281c58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f281c58e",
  null
  
)

export default component.exports